
import Hubspot from './hubspot'
import strings from '@/helpers/strings'

/**
 * Hubspot instance defined for use in this plugin.
 */
const hubspot = new Hubspot()

/**
 * Plugin installer.
 */
export default {
    /**
     * Mounts hubspot analytics to Vue.$hubspot and adds an event to Router.
     * @param {Vue} Vue
     * @param {Object} options
     * @param {Router} Router
     */
    install(Vue, options, Router) {
        // configure
        hubspot.enabled = options.enabled || false

        // add defined instance to Vue.$hubspot
        Object.defineProperty(Vue.prototype, '$hubspot', {
            get() {
                return hubspot
            },
        })

        // Track routes
        Router.afterEach(to => hubspot.track([ 'setPath', to.path + strings.toQuery(to.query) ]))
    },
}

/**
 * Enable hubspot tracking on the defined instance.
 */
export const enableHubspot = () => hubspot.enabled = true

/**
 * Disable hubspot tracking on the defined instance.
 */
export const disableHubspot = () => hubspot.enabled = false
